import React, { useState } from "react";
import {
  Box,
  Text,
  Flex,
  Image,
  Button,
  Divider,
  Spinner,
  useToast,
  Checkbox,
  useDisclosure,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "context/UserContext";

import Topbar from "components/topbar";
import SummaryModal from "./SummaryModal";
import MainLayout from "components/mainLayout";
import FormikInput from "components/formikInput";
import dumyImage from "assets/marketing-image.png";
import useGetLocations from "api/queries/useGetLocations";
import useGetBags from "api/queries/useGetBags";
import FormikSearchAbleTagSelect from "components/FormikSearchAbleTagSelect";

const DropAtLocation = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { user } = useUserContext();
  const [sort, setSort] = useState("newest");
  const [search, setSearch] = useState("");
  const {
    isOpen: isSummaryModalOpen,
    onOpen: onSummaryModalOpen,
    onClose: onSummaryModalClose,
  } = useDisclosure();

  const locationsQuery = useGetLocations();
  const locations = locationsQuery?.data?.data || [];

  const formik = useFormik({
    initialValues: {
      requested_by: user?.info?._id,
      // noOfItems: null,
      location: null,
      bagIds: [],
    },

    // onSubmit: (values) => handleSubmit(values),
  });

  const bagsQuery = useGetBags({
    seller_id: user?.info?._id,
    search: search,
    sort: sort,
  });

  const sentBags =
    bagsQuery?.data
      ?.flatMap((request) =>
        request.bags?.filter((bag) => bag.status === "sent")
      )
      ?.filter(Boolean) || [];

  const handleBagSelect = (bagId) => {
    if (!bagId) return;
    const existing = formik.values["bagIds"];
    if (existing.includes(bagId)) return; // prevent duplicates
    formik.setFieldValue("bagIds", [...existing, bagId]);
  };

  const handleBagRemove = (bagId) => {
    const updated = formik.values["bagIds"].filter((id) => id !== bagId);
    formik.setFieldValue("bagIds", updated);
  };

  // console.log('formik', formik);
  // console.log(
  //   "Bag IDs with status 'sent':",
  //   bagsQuery?.data
  //     ?.flatMap((request) =>
  //       request.bags
  //         ?.filter((bag) => bag.status === "sent") // only sent
  //         .map((bag) => bag.id)
  //     )
  //     .filter(Boolean) // remove null/undefined
  // );

  // useEffect(() => {
  //   const data = sellerQuery?.data?.data;
  //   if (data) {
  //     formik.setValues({
  //       ...formik.values,
  //       id: data?.id,
  //       title: data.title,
  //       first_name: data.first_name,
  //       surname: data.surname,
  //       email_address: data.email_address,
  //       contact_number: data.contact_number,
  //       address: data.address,
  //       city: data.city,
  //       postcode: data.postcode,
  //       bank_name: data.bank_name,
  //       account_number: data.account_number,
  //       sort_code: data.sort_code,
  //       international_bank_name: data.international_bank_name,
  //       international_account_number: data.international_account_number,
  //       international_sort_code: data.international_sort_code,
  //       discount: data?.discount,
  //       rejected_item_action: data.rejected_item_action,
  //       charity: data?.charity,
  //     });
  //   }
  // }, [sellerQuery?.data]);

  // useEffect(() => {
  //   if (formik.values.rejected_item_action === "Return to me") {
  //     formik.setFieldValue("charity", null);
  //   }
  // }, [formik.values.rejected_item_action]);

  return (
    <MainLayout>
      <Box minH={"100vh"} h={"100%"}>
        <Topbar title={"DROP OFF AT KWC LOCATION"} />
        <Flex bg={"#f8fbff"} padding={4} gap={2}>
          <Flex
            flex={1}
            direction={"column"}
            justifyContent={"space-between"}
            bg={"#FFFFFF"}
            padding={6}
            maxHeight={"100%"}
            borderRadius={"16px"}
            gap={6}
          >
            {/* <Box> */}
            <Text
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"24px"}
              lineHeight={"32px"}
              textTransform={"capitalize"}
              color={"#000000"}
            >
              Send Bag
            </Text>
            <Divider bg={"#8A8F9333"} h={"1px"} />
            <Box>
              <Flex flexDirection={"column"} gap={6}>
                <Box>
                  <Text
                    color={"#000000"}
                    fontFamily="PlusJakartaSansSemiBold"
                    fontSize={"16px"}
                    lineHeight={"22px"}
                    textTransform={"capitalize"}
                    mb={2}
                  >
                    Send Details
                  </Text>
                  <Box
                    border="1px solid #D9D9D9"
                    borderRadius="8px"
                    p={4}
                    gap={3}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    {/* <FormikInput
                      formik={formik}
                      name="noOfItems"
                      placeholder={"Enter the bags quantity"}
                      label={"No. of Bags"}
                      labelColor={"#000000"}
                    /> */}
                    <FormikSearchAbleTagSelect
                      formik={formik}
                      name="bagIds"
                      label="Select Bag IDs"
                      labelColor="black"
                      placeholder="Search Bag IDs..."
                      onSelectChange={(e) => handleBagSelect(e?.value)}
                    >
                      {sentBags.map((bag) => (
                        <option key={bag._id} value={bag._id}>
                          {bag.id}
                        </option>
                      ))}
                    </FormikSearchAbleTagSelect>
                    <Text
                      mt={"20px"}
                      color={"#000000"}
                      fontFamily="PlusJakartaSansSemiBold"
                      fontSize={"16px"}
                      lineHeight={"22px"}
                      textTransform={"capitalize"}
                    >
                      Selected Bags IDs
                    </Text>

                    <Flex
                      flexWrap="wrap"
                      gap="4px"
                      border="1px solid #D9D9D9"
                      p={4}
                      borderRadius="6px"
                    >
                      {formik.values.bagIds.map((id) => {
                        // find the bag object by its _id
                        const bag = sentBags?.find((b) => b._id === id);

                        return (
                          <Flex
                            key={id}
                            alignItems="center"
                            gap="4px"
                            minW="80px"
                            bg="#456EFF10"
                            px="16px"
                            py="12px"
                            borderRadius="8px"
                          >
                            <Text
                              color="#456EFF"
                              flex={1}
                              textAlign="center"
                              fontSize="12px"
                            >
                              {/* show the readable bag.id instead of _id */}
                              {bag ? bag.id : id}
                            </Text>
                            <Image
                              src={require("assets/svgs/x-circle.svg").default}
                              cursor="pointer"
                              h="16px"
                              w="16px"
                              onClick={() => handleBagRemove(id)}
                            />
                          </Flex>
                        );
                      })}
                    </Flex>
                  </Box>
                </Box>

                <Box>
                  <Text
                    color={"#000000"}
                    fontFamily="PlusJakartaSansSemiBold"
                    fontSize={"16px"}
                    lineHeight={"22px"}
                    textTransform={"capitalize"}
                    mb={2}
                  >
                    Drop-Off Location
                  </Text>
                  <Box
                    border="1px solid #D9D9D9"
                    borderRadius="8px"
                    p={4}
                    gap={4}
                    display={"flex"}
                    flexDirection={"column"}
                    maxH="270px" // adjust height to fit approximately 3 inputs
                    overflowY="auto"
                  >
                    {locationsQuery?.isLoading ? (
                      <Flex alignItems={"center"} justifyContent={"center"}>
                        <Spinner />
                      </Flex>
                    ) : (
                      locations.map((item, index) => {
                        return (
                          <Flex alignItems={"center"} gap={8}>
                            <Checkbox
                              isChecked={
                                formik.values.location?._id ===
                                item._id.toString()
                              }
                              onChange={() => {
                                formik.setFieldValue("location", item);
                              }}
                            />
                            {/* 
                            <Image
                              src={dumyImage}
                              alt="Thumbnail"
                              boxSize="70px"
                              borderRadius="4px"
                            /> */}
                            {/* Address Details */}
                            <Flex flex="1" justifyContent={"space-between"}>
                              <Text
                                fontFamily={"PlusJakartaSansMedium"}
                                fontSize={"14px"}
                                color={"#1E1E1E"}
                              >
                                {item?.name}
                              </Text>
                              <Text
                                fontFamily={"PlusJakartaSansMedium"}
                                fontSize={"14px"}
                                color={"#1E1E1E"}
                              >
                                {item?.postcode}
                              </Text>
                              <Text
                                fontFamily={"PlusJakartaSansMedium"}
                                fontSize={"14px"}
                                color={"#1E1E1E"}
                              >
                                {item?.address}
                              </Text>
                            </Flex>
                          </Flex>
                        );
                      })
                    )}
                  </Box>
                </Box>
              </Flex>
            </Box>

            <Flex
              alignSelf={"flex-end"}
              justifyContent={"flex-end"}
              w={"100%"}
              gap={2}
              mt={4}
            >
              <Button
                onClick={() => navigate("/send-a-bag")}
                flex={1}
                maxW={"148px"}
                background={"transparent"}
                color={"#000000"}
                border={"1px solid #000000"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  if (formik?.values?.location && formik?.values?.bagIds) {
                    onSummaryModalOpen();
                  } else {
                    toast({
                      title: "Missing Information",
                      description:
                        "Please select the bags ID and a drop-off location.",
                      status: "error",
                      duration: 3000,
                      isClosable: true,
                    });
                  }
                }}
                flex={1}
                maxW={"148px"}
                background={"#000000"}
                color={"#FFFFFF"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
                // isDisabled={editMutation.isLoading}
                _disabled={{
                  bg: "grey.100",
                  cursor: "default",
                  _hover: {
                    bg: "grey.100",
                    cursor: "default",
                  },
                }}
              >
                Save
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Box>
      <SummaryModal
        isOpen={isSummaryModalOpen}
        onClose={onSummaryModalClose}
        formik={formik}
        sentBags={sentBags}
      />
    </MainLayout>
  );
};

export default DropAtLocation;
